import io from 'socket.io-client';
import {uid} from 'uid';

class SocketClient {
    constructor() {
        this.subscriptionsSet = new Set();
        this.listenerMap = new Map();
        this.requestInterceptor = (request) => {
            return request
        };
        this.responseInterceptor = (response) => {
            return response
        };
    }

    connect(host, option = {}) {
        this.socket = io(host, {
            reconnection: true,
            reconnectionDelay: 200,
            reconnectionDelayMax: 8000,
            reconnectionAttempts: 99,
            transports: [ "websocket" ],
            ...option
        });
        this.socket.on('reconnect', () => {
            this.subscriptionsSet.forEach(request => this._createSubscription(request));
        });
        return this.socket;
    }

    _emit(type, request) {
        // console.log(type, request);
        this.socket.emit(type, this.requestInterceptor(request, type));
    }

    _createSubscription(request) {
        this._emit('SUBSCRIBE', request);
    }

    _removeSubscription(request) {
        if (this.listenerMap.get(request.action)) {
            if (this.listenerMap.get(request.action).length <= 1) {
                this.socket.removeListener(request.action);
                this.listenerMap.delete(request.action);
            } else {
                let listenerItems = this.listenerMap.get(request.action).filter(item => item.request.subscriptionId !== request.subscriptionId);
                this.listenerMap.set(request.action, listenerItems);
            }
        }
        this._emit('UNSUBSCRIBE', request);
        this.subscriptionsSet.delete(request);
    }

    updateSubscription(params, request) {
        request.params = params || request.params;
        this._emit('UPDATE_SUBSCRIPTION', request);
        this.subscriptionsSet.delete(request);
        this.subscriptionsSet.add(request);
    }

    _registerSubscription(request) {
        if (!this.subscriptionsSet.has(request)) {
            this.subscriptionsSet.add(request);
            this._createSubscription(request);
        }
    }

    _registerListener(request, listener) {
        if (!this.listenerMap.has(request.action)) {
            this.listenerMap.set(request.action, [{request, listener}]);
            this.socket.on(request.action, this._dispatch.bind(this));
        } else {
            let listenerItems = this.listenerMap.get(request.action);
            this.listenerMap.set(request.action, [...listenerItems, {request, listener}]);
        }
    }

    _dispatch(response) {
        if (this.listenerMap.has(response.action)) {
            let listenerItems = this.listenerMap.get(response.action).filter(item => item.request.subscriptionId === response.subscriptionId);
            listenerItems.forEach(listenerItem => listenerItem.listener(this.responseInterceptor({
                error: response.error,
                data: response.data,
                request: listenerItem.request
            })));
        }
    }

    subscribe(action, params = {}, headers = {}) {
        try {
            if (!action) throw new Error('Action cannot be empty string');
            let subscriptionId = uid(10);
            let request = {action, params, headers, subscriptionId};
            this._registerSubscription(request);
            return {
                onUpdate: (listener) => this._registerListener(request, listener),
                unsubscribe: () => this._removeSubscription(request),
                update: (params) => this.updateSubscription(params, request)
            }
        } catch (e) {
            console.error(e);
        }
    }
}

let socketClient = new SocketClient();
export default socketClient;